import style from './style.module.scss';

export default function Skeleton({
  width = 100,
  height = 10,
  radius = 4,
  variant = 'square',
}: {
  width?: string | number;
  height?: string | number;
  radius?: string | number;
  variant?: 'square' | 'hexagon';
}): JSX.Element {
  return (
    <div
      className={`${style['skeleton-box']} ${
        variant === 'hexagon' && style['skeleton-box--hexagon']
      }`}
      style={{
        width: width,
        height: height,
        borderRadius: variant !== 'hexagon' ? radius : 0,
      }}
    />
  );
}
